export const TMS_BRAND_KEY = "tmsBrand";



/** Locker Freight company — all others use Info-X TMS title after login */

export const LOCKER_FREIGHT_COMPANY_ID = 2;

export const TMS_BRAND = {

    INFOX: "infox",

    LOCKER_FREIGHT: "locker-freight",
    INFOX: "infox",
    LIMCO: "limco",
};

export const TMS_TITLES = {

    [TMS_BRAND.SHIPEZ]: "Info-X TMS",

    [TMS_BRAND.LOCKER_FREIGHT]: "Locker Freight TMS",
    [TMS_BRAND.INFOX]: "Info-X TMS",
    [TMS_BRAND.LIMCO]: "Limco Logistics TMS",
};

/**
 * Internal page browser-tab titles (longest-prefix match).
 * Mirrors legacy TMS tab naming (e.g. House Bill Of Lading, Address Book).
 * More specific paths must appear before shorter prefixes.
 */
export const INTERNAL_PAGE_TITLES = [
    // Ocean export reports
    ["/ocean/export/reports/booking-salesperson", "FCL Export Booking Salesperson Report"],
    ["/ocean/export/reports/destination-teu", "FCL Export Destination TEU Report"],
    ["/ocean/export/reports/doc-co-alert", "FCL Export Doc CO Alert Report"],
    ["/ocean/export/reports/top-50-customer", "FCL Export Top 50 Customer Report"],
    ["/ocean/export/reports/auto-cutoff", "FCL Export Auto Cutoff Report"],
    ["/ocean/export/reports/mbl-proofing", "FCL Export Master Bill Of Lading Proofing Report"],
    ["/ocean/export/reports/task-audit-report", "FCL Export Task Audit Report"],
    ["/ocean/export/reports/sales-person-report", "FCL Export Sales Person Report"],
    ["/ocean/export/reports/customer-loss", "FCL Export Customer Loss Report"],
    ["/ocean/export/reports/tues-report", "FCL Export TEUs Report"],
    ["/ocean/export/reports/activa-report", "FCL Export Activa Report"],
    ["/ocean/export/reports/onboard-report", "FCL Export Onboard Report"],
    ["/ocean/export/reports/daily-report-old-reference-number", "FCL Export Daily Report Old Reference"],
    ["/ocean/export/reports/daily-report", "FCL Export Daily Report"],
    ["/ocean/export/reports/italy-vessel-report", "FCL Export Italy Vessel Report"],
    ["/ocean/export/reports/profit-and-loss-report", "FCL Export Profit And Loss Report"],
    ["/ocean/export/reports/rate-quote", "FCL Export Rate Quote Report"],
    ["/ocean/export/reports/onboard-status", "FCL Export Onboard Status Report"],
    ["/ocean/export/reports/advanced-status", "FCL Export Advanced Status Report"],
    ["/ocean/export/reports/file-cancellation", "FCL Export File Cancellation Report"],
    ["/ocean/export/reports/booking", "FCL Export Booking Report"],
    ["/ocean/export/reports", "FCL Export Reports"],

    // Ocean import reports
    ["/ocean/import/reports/active-shipment", "FCL Import Active Shipment Report"],
    ["/ocean/import/reports/demurrage", "FCL Import Demurrage Report"],
    ["/ocean/import/reports/trucking", "FCL Import Trucking Report"],
    ["/ocean/import/reports/status-audit", "FCL Import Status Audit Report"],
    ["/ocean/import/reports/container-tracking", "FCL Import Container Tracking Report"],
    ["/ocean/import/reports/arrival-notice-pre-alert-report", "FCL Import Arrival Notice Pre Alert Report"],
    ["/ocean/import/reports/arrival-notice", "FCL Import Arrival Notice Report"],
    ["/ocean/import/reports/eta-status", "FCL Import ETA Status Report"],
    ["/ocean/import/reports/file-cancellation-report", "FCL Import File Cancellation Report"],
    ["/ocean/import/reports/profit-and-loss-based-on-booking", "FCL Import Profit And Loss Based On Booking"],
    ["/ocean/import/reports/gross-profit-loss-report", "FCL Import Gross Profit Loss Report"],
    ["/ocean/import/reports/profit-loss-report", "FCL Import Profit Loss Report"],
    ["/ocean/import/reports/rate-quote-report", "FCL Import Rate Quote Report"],
    ["/ocean/import/reports/booking", "FCL Import Booking Report"],
    ["/ocean/import/reports", "FCL Import Reports"],

    // Ocean export documents — full names, not abbreviations
    ["/hblPrint", "House Bill Of Lading"],
    ["/certificateOfOriginPrint", "FCL Export Certificate Of Origin"],
    ["/customerInvoicePrint", "FCL Export Customer Invoice"],
    ["/preAlertPrint", "FCL Export Pre Alert"],
    ["/workOrderPrint", "FCL Export Work Order"],
    ["/packingListPrint", "FCL Export Packing List"],
    ["/fcrPrint", "FCL Export Forwarder Cargo Receipt"],
    ["/customsInstructionsPrint", "FCL Export Customs Instructions"],
    ["/transportOrderPrint", "FCL Export Transport Order"],
    ["/coverPagePrint", "FCL Export Cover Page"],
    ["/securityEndorsementPrint", "FCL Export Security Endorsement"],
    ["/screeningConsentPrint", "FCL Export Screening Consent"],
    ["/hbl", "House Bill Of Lading"],
    ["/mblPrint", "Master Bill Of Lading"],
    ["/mbl", "Master Bill Of Lading"],
    ["/dock-receipt", "Dock Receipt"],

    // Ocean export — rate quote / booking
    ["/rate-quote/print", "FCL Export Rate Quote Print"],
    ["/rate-quote/new", "FCL Export New Rate Quote"],
    ["/rate-quote/edit", "FCL Export Edit Rate Quote"],
    ["/cancel-rate-quote", "FCL Export Cancel Rate Quote"],
    ["/rate-quote", "FCL Export Rate Quote"],
    ["/booking-request-list", "FCL Export Booking Request"],
    ["/booking-request/new", "FCL Export New Booking Request"],
    ["/booking-request/edit", "FCL Export Edit Booking Request"],
    ["/booking-request/print", "FCL Export Booking Request Print"],
    ["/booking/shipper-instruction-letter", "FCL Export Shipper Instruction Letter"],
    ["/booking/print-non-freighted", "FCL Export Booking Print"],
    ["/booking/pdf-demo", "FCL Export Booking Print"],
    ["/booking/print", "FCL Export Booking Print"],
    ["/booking/cancel", "FCL Export Cancel Booking"],
    ["/booking/new", "FCL Export New Booking"],
    ["/booking/edit", "FCL Export Edit Booking"],
    ["/booking", "FCL Export Home"],
    ["/job-costing", "FCL Export Job Costing"],
    ["/status-audit", "FCL Export Status Audit"],
    ["/quotation-report", "FCL Export Quotation Report"],
    ["/booking-report", "FCL Export Booking Report"],
    ["/accounting-report", "FCL Export Accounting Report"],

    // Ocean import
    ["/import-rate-quote/print", "FCL Import Rate Quote Print"],
    ["/import-rate-quote/new", "FCL Import New Rate Quote"],
    ["/import-rate-quote/edit", "FCL Import Edit Rate Quote"],
    ["/import-cancel-rate-quote", "FCL Import Cancel Rate Quote"],
    ["/import-rate-quote", "FCL Import Rate Quote"],
    ["/import-booking/PrintLockerFreight", "FCL Import Booking Print"],
    ["/import-booking/PrintNonFreight", "FCL Import Booking Print"],
    ["/import-booking/Print", "FCL Import Booking Print"],
    ["/import-booking/status-audit", "FCL Import Status Audit"],
    ["/import-status-audit/print", "FCL Import Status Audit Print"],
    ["/import-hbl-print", "FCL Import House Bill Of Lading"],
    ["/import-pre-alert-consignee-print", "FCL Import Pre Alert"],
    ["/import-booking-confirmation-print", "FCL Import Booking Confirmation"],
    ["/import-isf-print", "FCL Import ISF"],
    ["/import-booking/cancel", "FCL Import Cancel Booking"],
    ["/import-cancel-booking", "FCL Import Cancel Booking"],
    ["/import-booking/new", "FCL Import New Booking"],
    ["/import-booking/edit", "FCL Import Edit Booking"],
    ["/import-booking-fcl", "FCL Import Booking"],
    ["/import-booking-lcl", "FCL Import Booking"],
    ["/import-booking", "FCL Import Home"],
    ["/import-job-costing", "FCL Import Job Costing"],
    ["/import-quotation-report", "FCL Import Quotation Report"],
    ["/import-booking-report", "FCL Import Booking Report"],

    // Air export / import — same naming pattern
    ["/air/export/rate-quote/print", "Air Export Rate Quote Print"],
    ["/air/export/rate-quote/new", "Air Export New Rate Quote"],
    ["/air/export/rate-quote", "Air Export Rate Quote"],
    ["/air/export/rate-quotes", "Air Export Rate Quote"],
    ["/air/export/cancel-quotes", "Air Export Cancel Rate Quote"],
    ["/air/export/cancel-shipments", "Air Export Cancel Shipment"],
    ["/air/export/online-bookings", "Air Export Online Booking"],
    ["/air/export/booking", "Air Export Booking"],
    ["/air/export/shipments", "Air Export Shipment"],
    ["/air/export/reports/top-50-customer", "Air Export Top 50 Customer Report"],
    ["/air/export/reports", "Air Export Reports"],
    ["/air/export/quotation-report", "Air Export Quotation Report"],
    ["/air/export/booking-report", "Air Export Booking Report"],
    ["/air/import/rate-quote/print", "Air Import Rate Quote Print"],
    ["/air/import/rate-quote/new", "Air Import New Rate Quote"],
    ["/air/import/rate-quote", "Air Import Rate Quote"],
    ["/air/import/rate-quotes", "Air Import Rate Quote"],
    ["/air/import/cancel-quotes", "Air Import Cancel Rate Quote"],
    ["/air/import/cancel-shipments", "Air Import Cancel Shipment"],
    ["/air/import/pre-alert", "Air Import Pre Alert"],
    ["/air/import/arrival-notice", "Air Import Arrival Notice"],
    ["/air/import/customs", "Air Import Customs"],
    ["/air/import/delivery-order", "Air Import Delivery Order"],
    ["/air/import/cargo-delivery", "Air Import Cargo Delivery"],
    ["/air/import/pod", "Air Import Proof Of Delivery"],
    ["/air/import/booking", "Air Import Booking"],
    ["/air/import/shipments", "Air Import Shipment"],
    ["/air/import/quotation-report", "Air Import Quotation Report"],
    ["/air/import/booking-report", "Air Import Booking Report"],
    ["/air/dashboard", "Air Dashboard"],

    // Domestic export / import
    ["/domestic/export/rate-quote/new", "Domestic Export New Rate Quote"],
    ["/domestic/export/rate-quote", "Domestic Export Rate Quote"],
    ["/domestic/export/rate-quotes", "Domestic Export Rate Quote"],
    ["/domestic/export/work-order/new", "Domestic Export New Work Order"],
    ["/domestic/export/work-order", "Domestic Export Work Order"],
    ["/domestic/export/work-orders", "Domestic Export Work Order"],
    ["/domestic/export/quotation-report", "Domestic Export Quotation Report"],
    ["/domestic/export/booking-report", "Domestic Export Booking Report"],
    ["/domestic/export/reports", "Domestic Export Reports"],
    ["/domestic/import/rate-quote/new", "Domestic Import New Rate Quote"],
    ["/domestic/import/rate-quote", "Domestic Import Rate Quote"],
    ["/domestic/import/rate-quotes", "Domestic Import Rate Quote"],
    ["/domestic/import/work-order/new", "Domestic Import New Work Order"],
    ["/domestic/import/work-order", "Domestic Import Work Order"],
    ["/domestic/import/work-orders", "Domestic Import Work Order"],
    ["/domestic/import/quotation-report", "Domestic Import Quotation Report"],
    ["/domestic/import/booking-report", "Domestic Import Booking Report"],
    ["/domestic/import/reports", "Domestic Import Reports"],

    // Shared / masters — not export or import modules
    ["/address-book", "Address Book"],
    ["/shipment-events", "Shipment Events"],
    ["/ocean/schedule", "Ocean Schedule"],
    ["/ocean/tracking", "Ocean Tracking"],
    ["/ratematrix", "Rate Matrix"],
    ["/rate-agent", "Rate Agent"],
    ["/ratesagent", "Rates Agent"],
    ["/ocean-control-tower", "Ocean Control Tower"],
    ["/ai-agent-dashboard", "AI Agent Dashboard"],
    ["/ai-agent-setup", "AI Agent Setup"],
    ["/modules", "FCL Export Module"],
    ["/dashboard", "Dashboard"],
    ["/forwarder-dashboard", "Forwarder Dashboard"],
    ["/operations-dashboard", "Operations Dashboard"],
    ["/mailbox", "Mailbox"],
    ["/financials", "Financials"],
    ["/customs", "Customs"],
    ["/containers", "Containers"],
    ["/rfq", "RFQ"],
    ["/ShipmentList", "Shipment List"],
    ["/purchase-orders", "Purchase Orders"],
    ["/sales-orders", "Sales Orders"],
    ["/load-plan", "Load Plan"],
    ["/wms", "WMS"],
    ["/warehousing", "Warehousing"],
    ["/composer", "Composer"],
    ["/vision-board", "Vision Board"],
    ["/api-connect", "API Connect"],
    ["/email-summary", "Email Summary"],
    ["/quotes-bookings", "Quotes & Bookings"],
];

const AUTH_PUBLIC_PATH_PREFIXES = [
    "/login",
    "/locker-freight/login",
    "/infox/login",
    "/limco/login",
    "/signin",
    "/signup",
    "/quote-response",
];

export function getTitleForBrand(brand) {

    return TMS_TITLES[brand] || TMS_TITLES[TMS_BRAND.INFOX];

}

export function getBrandFromPath(pathname = "") {
    if (pathname === "/locker-freight/login" || pathname.includes("locker-freight")) {
        return TMS_BRAND.LOCKER_FREIGHT;
    }
    if (pathname === "/infox/login" || pathname.includes("/infox/login")) {
        return TMS_BRAND.INFOX;
    }

    return TMS_BRAND.INFOX;

}

export function getBrandFromCompanyId(companyId) {
    const id = Number(companyId);
    if (id === LOCKER_FREIGHT_COMPANY_ID) {
        return TMS_BRAND.LOCKER_FREIGHT;
    }

    return TMS_BRAND.INFOX;

}

export function getAuthUserFromStorage() {
    try {
        const stored = localStorage.getItem("authUser");
        if (!stored) return null;
        const parsed = JSON.parse(stored);
        return Array.isArray(parsed) ? parsed[0] : parsed;
    } catch {
        return null;
    }
}

export function persistTmsBrand(brand) {
    sessionStorage.setItem(TMS_BRAND_KEY, brand);
}

export function getPersistedTmsBrand() {

    return sessionStorage.getItem(TMS_BRAND_KEY) || TMS_BRAND.INFOX;

}

export function applyTmsDocumentTitle(brand) {
    document.title = getTitleForBrand(brand);
}

function normalizePathname(pathname = "") {
    const p = String(pathname).split("?")[0].split("#")[0].replace(/\/+$/, "");
    return p || "/";
}

function isAuthPublicPath(pathname = "") {
    const path = normalizePathname(pathname);
    return AUTH_PUBLIC_PATH_PREFIXES.some(
        (prefix) => path === prefix || path.startsWith(`${prefix}/`),
    );
}

/** Longest-prefix match for internal browser tab titles. */
export function getInternalPageTitle(pathname = "") {
    const path = normalizePathname(pathname);

    // Air waybills use the full document name, same as House / Master Bill Of Lading.
    if (/\/hawb$/.test(path)) {
        return path.includes("/import/")
            ? "Air Import House Air Waybill"
            : "Air Export House Air Waybill";
    }
    if (/\/mawb$/.test(path)) {
        return path.includes("/import/")
            ? "Air Import Master Air Waybill"
            : "Air Export Master Air Waybill";
    }

    let bestTitle = null;
    let bestLen = 0;

    for (const [prefix, title] of INTERNAL_PAGE_TITLES) {
        if (!prefix || !title) continue;
        const matches = path === prefix || path.startsWith(`${prefix}/`);
        if (matches && prefix.length > bestLen) {
            bestLen = prefix.length;
            bestTitle = title;
        }
    }

    return bestTitle;
}

/** After login / new tab — title from authUser.companyId (localStorage) */
export function applyAuthenticatedTmsDocumentTitle() {
    const hasToken = Boolean(localStorage.getItem("authToken"));
    if (!hasToken) return;

    const user = getAuthUserFromStorage();
    const companyId = user?.companyId ?? user?.CompanyId;

    if (companyId !== undefined && companyId !== null && companyId !== "") {
        const brand = getBrandFromCompanyId(companyId);
        persistTmsBrand(brand);
        applyTmsDocumentTitle(brand);
        return;
    }

    applyTmsDocumentTitle(getPersistedTmsBrand());
}

/**
 * Authenticated app: use page-specific tab titles when known;
 * otherwise keep the existing brand TMS title behavior.
 * Login/signup routes are left alone (those pages set their own title).
 */
export function applyRouteAwareDocumentTitle(pathname = "") {
    if (isAuthPublicPath(pathname)) return;

    const hasToken = Boolean(localStorage.getItem("authToken"));
    if (!hasToken) return;

    // Keep brand persistence in sync (same as applyAuthenticatedTmsDocumentTitle)
    const user = getAuthUserFromStorage();
    const companyId = user?.companyId ?? user?.CompanyId;
    if (companyId !== undefined && companyId !== null && companyId !== "") {
        persistTmsBrand(getBrandFromCompanyId(companyId));
    }

    const pageTitle = getInternalPageTitle(pathname);
    if (pageTitle) {
        document.title = pageTitle;
        return;
    }

    applyAuthenticatedTmsDocumentTitle();
}

export function clearTmsBrand() {
    sessionStorage.removeItem(TMS_BRAND_KEY);
}
